export const registerServiceWorker = async (serviceWorkerPath: string) => {
  try {
    return await navigator.serviceWorker.register(serviceWorkerPath, {
      scope: "/",
    });
  } catch (err) {
    console.error("Unable to register sw, ", err);
  }
};
